module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-winter-1500.6ecf9c21.svg";